<template>
  <div v-if="typeof floor != 'undefined' && !isNaN(floor)">
    <header class="floor-preview__header">
      <h3 class="floor-preview__number">{{ $t('floor') }}: {{ floor }}</h3>
    </header>

    <div class="floor-preview__info">
      <div class="floor-preview__data">
        <p class="floor-preview__label">{{ $t('tooltip.flatNumber') }}:</p>
        <p class="floor-preview__value">
          {{ flats.length }}
        </p>
      </div>
      <div class="floor-preview__data">
        <p class="floor-preview__label">{{ $t('tooltip.available') }}:</p>
        <p class="floor-preview__value">
          {{ available.length }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: ['floor', 'building'],
  computed: {
    ...mapState({ flatProperties: state => state.browser.flatProperties }),
    flats() {
      return this.$store.getters.GET_FILTERED_FLATS_BY_BUILDING_AND_FLOOR(
        this.building,
        this.floor
      );
    },
    available() {
      return this.flats.filter(
        flat =>
          flat[this.flatProperties['status']] ==
          this.flatProperties['status_available']
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.floor-preview__header {
  border-bottom: 1px solid $lightGray;
}
.floor-preview__number {
  font-weight: 400;
  font-size: 20px;
}
.floor-preview__info {
  margin-top: 4px;
}
.floor-preview__data {
  display: flex;
  align-items: center;
  margin: 4px auto;
}
.floor-preview__value {
  font-size: 12px;
  font-weight: 400;
}
.floor-preview__label {
  font-size: 12px;
  margin-right: 6px;
  color: rgba(#000000, 0.5);
}
</style>
